import { useState } from "react";
import { X, Loader2 } from "lucide-react";
import { Label } from "../ui/Label";
import { Input } from "../ui/Input";
import { Textarea } from "../ui/Textarea";
import { Button } from "../ui/Button";
import { brandService } from "../../services/brands";
import { toast } from "sonner";

interface AddBrandModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: (data: any) => void;
}

export function AddBrandModal({ isOpen, onClose, onSuccess }: AddBrandModalProps) {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    active: true
  });

  if (!isOpen) return null;

  const handleSave = async () => {
    if (!formData.name) {
      toast.error("O nome é obrigatório");
      return;
    }

    try {
      setLoading(true);
      const response = await brandService.create(formData);
      toast.success("Marca salva com sucesso!");
      onSuccess(response.data || response);
      onClose();
    } catch (error: any) {
      toast.error(error.response?.data?.message || "Erro ao salvar");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-[100] bg-black/20 backdrop-blur-md">
      <div className="bg-white rounded-lg p-6 w-full max-w-md relative border border-gray-200 shadow-xl text-black">
        <button onClick={onClose} className="absolute top-3 right-3 text-white bg-[#D4C070] hover:bg-[#D4C070] rounded-full p-1 z-10">
          <X className="h-5 w-5" />
        </button>

        <h3 className="text-lg font-semibold mb-4 text-gray-900">Adicionar Marca</h3>

        <div className="space-y-4">
          <div>
            <Label className="block text-sm font-medium text-gray-700">Nome</Label>
            <Input value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} placeholder="Nome da marca" className="border-gray-300 mt-1" />
          </div>

          <div>
            <Label className="block text-sm font-medium text-gray-700">Descrição</Label>
            <Textarea value={formData.description} onChange={(e) => setFormData({ ...formData, description: e.target.value })} placeholder="Descrição da marca" rows={3} className="border-gray-300 mt-1" />
          </div>
        </div>

        <div className="mt-6 flex justify-end gap-2">
          <Button variant="outline" onClick={onClose} disabled={loading}>Cancelar</Button>
          <Button onClick={handleSave} className="bg-[#D4C070] hover:bg-[#849D70] text-white" disabled={loading}>
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Salvar"}
          </Button>
        </div>
      </div>
    </div>
  );
}
